//KRP1109
(function () {

    function funcReady() {
        $('.KRP1109').buildCommonUI();

        var KRP1109 = {
            init: function() {
                var self = this;

                self.setting();
                self.bindEvents();

                vcui.require(['ui/carousel'], function () {
                    // BTOCSITE-41905
                    //self.requestListData();
                })
            },
            setting: function() {
                var self = this;

                self.$component = $('section.component.KRP1109');
                self.$componentWrap = self.$component.closest('.component-wrap')
                self.$carousel = self.$component.find('.component-product__carousel');
                self.$productItem = self.$carousel.find('.component-product__item');
                self.listTemplate =
                    '{{#each item in itemList}}' +
                    '<div class="slide-conts ui_carousel_slide component-product__item">' +
                    '    <a href="{{item.link}}" class="component-product__item-wrap">' +
                    '        <div class="item__image" aria-hidden="true"><img src="{{item.mediumImageUrl}}" alt=""></div>' +
                    '        <div class="item__infos">' +
                    '            <div class="item__name">{{item.modelDisplayName}}</div>' +
                    '            <div class="item__sku">{{item.modelName}}</div>' +
                    '            <div class="item__price-wrap">' +
                    '                <em class="blind">판매가격</em>' +
                    '{{#if careType == true}}' +
                    '                <span class="item__price">월 {{item.years1TotAmtPrice}}<em>원</em></span>' +
                    '                <div class="item__price-desc">({{parseInt(item.visitPer)}}개월/1회 방문)</div>' +
                    '{{#else}}' +
                    '                <span class="item__price">{{item.currentPrice}}<em>원</em></span>' +
                    '{{/if}}' +
                    '            </div>' +
                    '        </div>' +
                    '    </a>' +
                    '</div>' +
                    '{{/each}}';
            },

            bindEvents: function() {
                var self = this;
            },
            carousel: function(){
                var self = this;

                if( self.$component.hasClass('is-active')) {
                    if(window.innerWidth < 768) {
                        self.$carousel.vcCarousel('destroy');
                    } else {
                        self.$carousel.vcCarousel({
                            infinite: false,
                            pauseOnHover: false,
                            pauseOnFocus: false,
                            swipeToSlide: true,
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            arrows: true,
                            touchThreshold: 100,
                            cssEase: 'cubic-bezier(0.33, 1, 0.68, 1)',
                            speed: 150
                        });
                    }
                }
            },
            resize: function(){
                var self = this;
                self.carousel();
            }

        };
        KRP1109.init();

        $(window).on('resizeend', function(){
            KRP1109.resize();
        });
    }

    // BTOCSITE-26022, PDP 컴포넌트 초기화 함수 추가, type: PROD or CONTENTS
    function SAVE_COMPONENT_PDP_DOM_MNG() {
        if (typeof __PDP_DOM_MNG__ === 'undefined') return;
        __PDP_DOM_MNG__.add({
            type: 'CONTENTS', name: 'KRP1109', isFirstLoad: false, fn: function () {
                if(!document.querySelector('.KRP1109')) return false;
                funcReady();
            }
        });
    }

    SAVE_COMPONENT_PDP_DOM_MNG();

    $(document).ready(function(){
        SAVE_COMPONENT_PDP_DOM_MNG();

        if(!document.querySelector('.KRP1109')) return false;
        funcReady();
    });
})();